/* eslint-disable react/jsx-props-no-spreading */
import { useResizeObserver } from '@folklore/hooks';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import * as AppPropTypes from '../../lib/PropTypes';

import Image from '../partials/Image';
import ImageCaption from '../typography/ImageCaption';

import styles from '../../styles/blocks/image-block.module.css';

const propTypes = {
    media: AppPropTypes.video.isRequired,
    size: PropTypes.bool,
    presentation: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    size: 'responsive',
    presentation: null,
    className: null,
};

function ImageBlock({ media, size, caption, presentation, className }) {
    const { credits = null } = media || {};
    const {
        ref: refResize,
        entry: { contentRect = null },
    } = useResizeObserver();
    const { width: containerWidth, height: containerHeight } = contentRect || {};
    return (
        <figure
            className={classNames([
                styles.container,
                {
                    [styles.fullwidth]: presentation === 'full',
                    [className]: className !== null,
                },
            ])}
            ref={refResize}
        >
            <Image
                media={media}
                width={containerWidth}
                height={containerHeight}
                loading="lazy"
                size={size}
                alt={caption}
                withoutSize
                className={styles.image}
                pictureClassName={styles.picture}
            />
            {credits !== null ? <ImageCaption className={styles.credits} html={credits} /> : null}
            {caption !== null ? (
                <ImageCaption
                    className={classNames([
                        styles.caption,
                        {
                            [styles.withCredits]: credits !== null,
                        },
                    ])}
                    html={caption}
                />
            ) : null}
        </figure>
    );
}

ImageBlock.propTypes = propTypes;
ImageBlock.defaultProps = defaultProps;

export default ImageBlock;
